import styled from "styled-components";

export const HeaderComp = styled.nav`
  position: fixed;
  width: 100vw;
  z-index: 2;
  background-color: white;
  border-radius: 0px 0px 5px 5px;
  border-bottom: 2px solid lightgrey;
  margin-left: -8px;
  margin-top: 0px;
  @media (max-width: 768px) {
    width: 103vw;
  }
  .desk {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .icon {
      margin-left: 60px;
    }

    @media (max-width: 700px) {
      display: none;
    }

    & ul {
      display: flex;
      flex-direction: row;
      gap: 40px;
      text-decoration: none;
      margin-right: 45px;
      list-style-type: none;
      & a {
        text-decoration: none;
        color: black;
      }
      & #menu-home {
        background-image: linear-gradient(
          transparent 0%,
          transparent 90%,
          #019ACB 98%,
          #019ACB 100%
        );
        background-repeat: no-repeat;
        background-size: 0% 100%;
        background-position-x: right;
        transition: background-size 300ms;
        &:hover {
          background-size: 100% 100%;
          background-position-x: left;
        }
      }
    }
  }

  .mob {
    width: 50vw;
    padding: 10px;
    @media (max-width: 695px) {
      display: inline-block;
      width: 50vw;
    }
    @media (min-width: 695px) {
      display: none;
    }
    & ul {
      list-style: none;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      & #menu-home {
        background-image: linear-gradient(
          transparent 0%,
          transparent 90%,
          #019ACB 98%,
          #019ACB 100%
        );
        background-repeat: no-repeat;
        background-size: 0% 100%;
        background-position-x: right;
        transition: background-size 300ms;
        &:hover {
          background-size: 100% 100%;
          background-position-x: left;
        }
      }

      & li {
        margin-left: -20px;
        margin-right: 28px;
        & a {
          text-decoration: none;
          color: black;
        }
      }
    }
  }
`;
